import { api } from './api';

export const quickOrderProductsApi = api.injectEndpoints({
	endpoints: (builder) => ({
		quickOrderAddExistingProduct: builder.mutation({
			query: (payload: { quickOrderId: number, productId: number, quantity: number }) => ({
				url: `/quickOrders/${payload.quickOrderId}/addExistingProduct`,
				method: 'POST',
				body: payload,
			}),
			invalidatesTags: ['QuickOrderInfo', 'PlanQuickOrdersList'],
		}),
		quickOrderAddNewProduct: builder.mutation({
			query: (payload: { quickOrderId: number, productId: number, quantity: number, name: string, sku: string, uom: string }) => ({
				url: `/quickOrders/${payload.quickOrderId}/addNewProduct`,
				method: 'POST',
				body: payload,
			}),
			invalidatesTags: ['QuickOrderInfo', 'PlanQuickOrdersList'],
		}),
		quickOrderDeleteProduct: builder.mutation({
			query: (orderProductId: string) => ({
				url: `/quickOrderProducts/${orderProductId}`,
				method: 'DELETE',
			}),
			invalidatesTags: ['QuickOrderInfo', 'PlanQuickOrdersList'],
		}),
		quickOrderRemove: builder.mutation({
			query: (orderId: string) => ({
				url: `/quickOrders/${orderId}`,
				method: 'DELETE',
			}),
		}),
		quickOrderEditProduct: builder.mutation({
			query: (payload: { id: number, uom?: string, quantity?: string, pricePerUnit?: string, isBundled?: boolean }) => ({
				url: `/quickOrderProducts/${payload.id}`,
				method: 'PUT',
				body: payload,
			}),
			invalidatesTags: ['QuickOrderInfo', 'PlanQuickOrdersList'],
		}),
	}),
});

export const {
	useQuickOrderAddExistingProductMutation,
	useQuickOrderAddNewProductMutation,
	useQuickOrderDeleteProductMutation,
	useQuickOrderRemoveMutation,
	useQuickOrderEditProductMutation,
} = quickOrderProductsApi;
